"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Tabs = require("../Tabs/Tabs.context");
var _TabPanel = require("./TabPanel.styles");
var _excluded = ["id", "aria-labelledby"];
/**
 * A `Tabs.Panel` is a child of a `Tabs.Panels` component.
 *
 * @since 8.10.0
 */
var TabPanel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var id = _ref.id,
    ariaLabelledby = _ref['aria-labelledby'],
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_Tabs.TabsContext);
  var selectedTabId = context.selected || context.selectedState;
  return /*#__PURE__*/_react.default.createElement(_TabPanel.StyledTabPanel, (0, _extends2.default)({
    "aria-labelledby": ariaLabelledby,
    id: typeof id !== 'undefined' ? id : ariaLabelledby + "_panel",
    hidden: ariaLabelledby !== selectedTabId,
    ref: forwardedRef,
    tabIndex: ariaLabelledby === selectedTabId ? '0' : '-1'
  }, rest));
});
exports.TabPanel = TabPanel;
TabPanel.displayName = 'Tabs.Panel';
TabPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This must match the `id` of the `Tabs.Tab` associated with this panel.
   */
  'aria-labelledby': _propTypes.default.string.isRequired,
  /**
   * If true, panel is hidden. This prop is automatically set by the component.
   */
  'hidden': _propTypes.default.bool,
  /**
   * This must match the `aria-controls` of the `Tabs.Tab`
   * associated with this panel.
   *
   * If no `id` is specified, one will automatically be generated.
   */
  'id': _propTypes.default.string,
  /**
   * This should always be "tabpanel". Defining as a prop solely so we can streamline the
   * `Tabs.Panel` instantiation.
   *
   * @ignore
   */
  'role': _propTypes.default.string
} : {};
TabPanel.defaultProps = {
  role: 'tabpanel'
};